import { render, staticRenderFns } from "./priceReview.vue?vue&type=template&id=456c5a8a&scoped=true&"
import script from "./priceReview.vue?vue&type=script&lang=js&"
export * from "./priceReview.vue?vue&type=script&lang=js&"
import style0 from "./priceReview.vue?vue&type=style&index=0&id=456c5a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c5a8a",
  null
  
)

export default component.exports